import { createStyles } from '@mantine/styles';


export default createStyles((
    theme: {
        colors: { [x: string]: any[] };
        other: any;
        spacing: any;
        colorScheme: any;
        shadows: any;
        radius: any;
        fn: any;
    }) => ({

    propertyDetailsLanding: {
        margin: '0 auto',
        maxWidth: theme.other.maxWidth,
    },

    propertyDetailsGrid: {
        flexDirection: 'row-reverse',

        /*[theme.fn.smallerThan('md')]: {
            flexDirection: 'row-reverse',
        },*/
    },

    propertyDetailsDiv: {
        width: '58%',
        marginTop: 20,
        [theme.fn.smallerThan('md')]: {
            width: '100%',
        },
    },

    propertyBookingDiv: {
        width: '38%',
        marginTop: 20,
        marginBottom: 20,
        [theme.fn.largerThan('md')]: {
            position: 'sticky',
            top: 20,
        },
        [theme.fn.smallerThan('md')]: {
            width: '100%',
        },
    },

}));
